
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nrf",
      function () {
        return require("private-next-pages/nrf/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nrf"])
      });
    }
  